
export function ds24_confirm( obj: HTMLElement )
{
    var msg = obj.getAttribute( 'app-confirm-msg' );
    if (!msg) {
        return true;
    }

    window.DS24_HOVER_DISABLED = true;
    var is_confirmed = confirm( msg );
    window.setTimeout( () => window.DS24_HOVER_DISABLED = false, 200 );
    return is_confirmed;
}
